import React, { memo, useState } from 'react';
import DATA from '../../../assets/data';
import './demandPlannerSecMat.scss';

const GridTable = memo((props) => {

    const [selectedIndex, setIndex] = useState(null)

    const computeTotal = (yearData, valueToComputeTotal) => {
        let total = 0;
        if (yearData.length) {
            yearData.forEach((value, index) => {
                if (index < 12) {
                    value.monthData.forEach((item, ind) => {
                        if (item.label === valueToComputeTotal) {
                            total = total + item.value
                        }
                    })
                }
            })
        }

        return valueToComputeTotal === 'MonthVolume' ? total?.toFixed(0) : total?.toFixed(2);
    }

    // const computeQuarterTotal = (val1, val2, val3, val4) => {
    //     let total = 0;
    //     if (val1) {
    //         total = total + parseFloat(val1);
    //     }
    //     if (val2) {
    //         total = total + parseFloat(val2);
    //     }
    //     if (val3) {
    //         total = total + parseFloat(val3);
    //     }
    //     if (val4) {
    //         total = total + parseFloat(val4);
    //     }

    //     return total === 0 ? null : total?.toFixed(2);
    // }

    const appendPercentageSymbol = (value) => {
        if (value) {
            return (value?.toFixed(2) + '%');
        }
        else {
            return null;
        }
    }

    return (
        <table className='dp-sec-mat-table'>
            <thead>
                <tr>
                    <th style={{ zIndex: 1 }} colSpan='15' className='dp-table-cell-borders bg-dark-blue top-position-0 fix-position'>{props.heading}</th>
                </tr>
                <tr>
                    <th style={{ zIndex: 1,padding:'0px 30px' }} className='dp-table-cell-borders bg-light-grey fix-position left-position-0 top-position-24' colSpan='2'>Gregorian</th>
                    {
                        DATA.QUARTER_MONTHS.map((item, ind) => (
                            <th style={{ zIndex: 1 }} key={item + ind} className='dp-table-cell-borders bg-light-grey fix-position top-position-24'>{item.name}</th>
                        ))
                    }
                    <th style={{ zIndex: 1 }} className='dp-table-cell-borders bg-light-grey fix-position top-position-24'>Total</th>
                </tr>
            </thead>
            <tbody>

                {
                    props.data && props.data.map((item, ind) => (
                        <React.Fragment key={`key${ind}`}>
                            <tr>
                                <td rowSpan='6' className='rotated-value-cell bg-light-grey fix-position left-position-0'>
                                    <span className='rotated-value'>{item.year}</span>
                                </td>
                            </tr>

                            {
                                props.visibleList.map((value, ind) => {
                                    return (
                                        <tr key={`key${ind}`}>
                                            <td className='dp-table-cell-borders bg-dark-blue fix-position left-position-102'>{props.visibleListLabels[ind]}</td>
                                            {
                                                item.yearData.map((elm, indx) => {       // eslint-disable-line
                                                    if (indx < 12) {
                                                        return <td key={elm + indx} className='dp-table-cell-borders' style={(value === 'MonthlyGrowth' || value === 'CommulativeGrowth') ? { fontWeight: 'bold' } : void 0}>
                                                            {
                                                                value === 'MonthVolume' ? (elm.monthData[0].value)?.toFixed(0)
                                                                    : value === 'Commulative' ? (elm.monthData[1].value)?.toFixed(0)
                                                                        : value === 'MonthlyGrowth' ? appendPercentageSymbol((elm.monthData[5].value))
                                                                            : value === 'CommulativeGrowth' ? appendPercentageSymbol((elm.monthData[6].value))
                                                                                : (elm.monthData[3].value)?.toFixed(0)
                                                            }
                                                        </td>
                                                    }
                                                })}
                                            <td className='dp-table-cell-borders total-cell'>{value === 'MonthVolume' ? computeTotal(item.yearData, value) : null}</td>
                                        </tr>
                                    )
                                })
                            }

                            {
                                ind === selectedIndex ?
                                    <>
                                        {props.hiddenList.map((value, indx) => {
                                            return (
                                                <tr key={`key${indx}`}>
                                                    <th style={{ backgroundColor: 'white' }} className='fix-position left-position-0'></th>
                                                    <td className='dp-table-cell-borders bg-dark-blue fix-position left-position-102'>{props.hiddenListLabels[indx]}</td>
                                                    {
                                                        item.yearData.map((elm, ind) => {       // eslint-disable-line
                                                            if (ind < 12) {
                                                                return <td key={elm + ind} className='dp-table-cell-borders' style={(value === 'AwsGrowth' || value === 'AdsGrowth') ? { fontWeight: 'bold' } : void 0}>
                                                                    {
                                                                        value === 'AwsGrowth' ? appendPercentageSymbol((elm.monthData[2].value))
                                                                            : value === 'Ads' ? (elm.monthData[4].value)?.toFixed(0)
                                                                                : appendPercentageSymbol((elm.monthData[6].value))
                                                                    }
                                                                </td>
                                                            }
                                                        })
                                                    }
                                                    <td className='dp-table-cell-borders total-cell'>
                                                        {/* {computeTotal(item.yearData, value)} */}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </>
                                    :
                                    null
                            }
                            {
                                props.visibleList2.map((elm, indx) => {
                                    return (
                                        <tr key={`key${indx}`}>
                                            <th style={{ backgroundColor: 'white' }} className='fix-position left-position-0'>
                                                {
                                                    indx === 0 ?
                                                        <>
                                                            {
                                                                ind === selectedIndex ?
                                                                    <>
                                                                        <span className='indentation-line'></span>
                                                                        <img style={{ cursor: 'pointer' }} src={require('../../../assets/images/minus-square.png')} alt='' onClick={() => setIndex(null)} />
                                                                    </>
                                                                    :
                                                                    <img style={{ cursor: 'pointer' }} src={require('../../../assets/images/plus-square.png')} alt='' onClick={() => setIndex(ind)} />
                                                            }
                                                        </>
                                                        :
                                                        null
                                                }
                                            </th>
                                            <td className={`dp-table-cell-borders fix-position left-position-102 
                                            ${(props.visibleList2Labels[indx] === 'Quarterly Volume') ? 'bg-light-blue'
                                                    : (props.visibleList2Labels[indx] === 'Quarterly Growth') ? 'bg-light-green'
                                                        : (props.visibleList2Labels[indx] === 'Seasonality') ? 'bg-light-purple' : ''}`}>
                                                {props.visibleList2Labels[indx]}</td>
                                            {
                                                item.yearData && Object.values(item.yearData).map((element, index) => {       // eslint-disable-line
                                                    if (index < 12) {
                                                        return (
                                                            <td key={element + index}
                                                                style={(props.visibleList2Labels[indx] === 'Quarterly Growth' || props.visibleList2Labels[indx] === 'Seasonality') ? { fontWeight: 'bold' } : void 0}
                                                                className={`dp-table-cell-borders 
                                                            ${((index === 2 || index === 5 || index === 8 || index === 11) && (props.visibleList2Labels[indx] === 'Quarterly Volume')) ? 'bg-light-blue'
                                                                        : ((index === 2 || index === 5 || index === 8 || index === 11) && (props.visibleList2Labels[indx] === 'Quarterly Growth')) ? 'bg-light-green'
                                                                            : ((index === 2 || index === 5 || index === 8 || index === 11) && (props.visibleList2Labels[indx] === 'Seasonality')) ? 'bg-light-purple' :
                                                                                ''}`}
                                                            >
                                                                {
                                                                    index === 2 ? (((elm + '1') === 'QuarterVolume1') ? Object.values(item.yearData[12])[0][elm + '1']?.toFixed(0) : appendPercentageSymbol(Object.values(item.yearData[12])[0][elm + '1']))
                                                                        : index === 5 ? (((elm + '2') === 'QuarterVolume2') ? Object.values(item.yearData[12])[0][elm + '2']?.toFixed(0) : appendPercentageSymbol(Object.values(item.yearData[12])[0][elm + '2']))
                                                                            : index === 8 ? (((elm + '3') === 'QuarterVolume3') ? Object.values(item.yearData[12])[0][elm + '3']?.toFixed(0) : appendPercentageSymbol(Object.values(item.yearData[12])[0][elm + '3']))
                                                                                : index === 11 ? (((elm + '4') === 'QuarterVolume4') ? Object.values(item.yearData[12])[0][elm + '4']?.toFixed(0) : appendPercentageSymbol(Object.values(item.yearData[12])[0][elm + '4']))
                                                                                    : null
                                                                }
                                                            </td>
                                                        )
                                                    }
                                                })
                                            }
                                            <td className='dp-table-cell-borders total-cell'>
                                                {/* {computeQuarterTotal((Object.values(item.yearData[12])[0][elm + '1']), (Object.values(item.yearData[12])[0][elm + '2']), (Object.values(item.yearData[12])[0][elm + '3']), (Object.values(item.yearData[12])[0][elm + '4']))} */}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </React.Fragment>
                    ))
                }
            </tbody>
        </table>
    );
})

export default GridTable;